module.exports = __webpack_public_path__ + "assets/img/addedServices.6ee3990b.png";